import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainApi } from '@/lib/api';
import { QUERY_KEYS, StoreType } from '@/lib/constants';
import { stanNotify } from '@/lib/stanNotify';
import type { CreateFunnelPagePayload } from '../../types';

export function useCreateFunnelPage(storeId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: CreateFunnelPagePayload) => {
            const response = await mainApi.put(`v1/stores/${storeId}/pages`, payload);
            return response.data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FUNNELS, 'detail', storeId] }),
                queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.STORE_DATA, StoreType.FUNNEL] }),
            ]);
            stanNotify({
                type: 'success',
                title: 'Page added!',
                text: 'Your product has been added to the funnel.',
                duration: 2000,
            });
        },
        onError: () => {
            stanNotify({
                type: 'error',
                title: 'Oops!',
                text: 'Failed to add page. Please try again.',
                duration: 2000,
            });
        },
    });
}
